/* ============================================================
   Expose the live API + bootstrap + mode flag on `window` BEFORE the feature
   modules evaluate. They read `window.WIDO_USE_API` / `window.WidoApi` /
   `window.WidoBootstrap` at module-eval time, so this must be imported ahead of
   them in main.js (right after setup-globals).
   ============================================================ */
import { api } from "./client.js";
import { loadAndApply, loadCritical, loadDeferred, refreshRoster, switchTo } from "./bootstrap.js";

window.WIDO_USE_API = import.meta.env.VITE_USE_API === "1";
// Whether to even probe the dev-login endpoint. Off by default (production), so
// the SPA never calls /api/auth/dev-users (no 404 noise, no demo chooser). Dev
// builds set VITE_DEV_LOGIN=1 to enable the seeded account switcher.
window.WIDO_DEV_LOGIN = import.meta.env.VITE_DEV_LOGIN === "1";
window.WidoApi = api;
window.WidoBootstrap = { loadAndApply, loadCritical, loadDeferred, refreshRoster, switchTo };
